import { DataService } from '../../services/data.service';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { IActivity, IModule } from 'src/app/interfaces/resource';
import * as firebase from 'firebase/app';
import { pushObjArray, pushToArray, pushToObject } from 'src/app/services/convert.service';

@Injectable()
export class ActivityStore {
    @observable data: any[] = [];
    
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable lastVisible: any = null;
    @observable fetching: boolean = false;
    @observable options: any[] = [];
    @observable words: any[] = [];

    constructor(private ds: DataService) { }

    @action
    updateWordsDownloadURL(item: IActivity, fileData, callback) {
        this.process = true;
        const { words } = item;
        const WORDS_DATA = pushObjArray(words, fileData)
        this.ds.batchCollectionRef().collection(COLLECTION_NAME.ACTIVITY).doc(item.key).update({
            words: WORDS_DATA
        }).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    updateBook(itemKey, field: any, value, callback) {
        this.process = true;
        this.ds.activityByModuleColRef(null).doc(itemKey).update({
            [field]: value,
        }).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    cloneActivity(item: IActivity, module: IModule, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(COLLECTION_NAME.ACTIVITY).doc(item.key);
        const moduleRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.MODULE).doc(item.moduleKey);
        batch.set(ref, item, { merge: true });
        batch.set(moduleRef, {
            ...module,
            activityKey: item.key,
            activityRef: this.ds.activityColRef().doc(item.key).ref,
            updated_by: item.updated_by,
            updated_byRef: item.updated_byRef,
            updated_at: item.updated_at
        }, { merge: true })
        batch.update(statisticRef, { [`${COLLECTION_NAME.ACTIVITY}`]: firebase.firestore.FieldValue.increment(1) });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }
    @action
    addItem(item: IActivity, module: IModule, isUpdate: boolean, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(COLLECTION_NAME.ACTIVITY).doc(item.key);
        const moduleRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.MODULE).doc(item.moduleKey);
        batch.set(ref, item, { merge: true });
        const moduleUpdate = {
            activityKey: item.key,
            activityRef: this.ds.activityColRef().doc(item.key).ref,
            updated_by: item.updated_by,
            updated_byRef: item.updated_byRef,
            updated_at: item.updated_at
        }
        batch.update(moduleRef, moduleUpdate)
        if (!isUpdate) {
            batch.update(statisticRef, { [`${COLLECTION_NAME.ACTIVITY}`]: firebase.firestore.FieldValue.increment(1) });
        }
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    update(item: IActivity, callback) {
        this.process = true;
        this.ds.batchCollectionRef().collection(COLLECTION_NAME.ACTIVITY).doc(item.key).update(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    updateActivitySoundURL(item: IActivity, url, uid, callback) {
        this.process = true;
        this.ds.batchCollectionRef().collection(COLLECTION_NAME.ACTIVITY).doc(item.key).update({
            soundDownloadURL: url,
            updated_at: new Date(),
            updated_by: uid,
            updated_byRef: this.ds.userProfileRef().doc(uid).ref,
        }).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async fetchActivityType() {
        return pushToArray(await this.ds.activityTypeRef().get().toPromise())
    }

    @action
    async fetchModule(moduleKey) {
        return pushToObject(await this.ds.moduleRef().doc(moduleKey).get().toPromise())
    }

    @observable fetchActivityRef: any = null;
    @action
    fetchActivity(key: any, callback) {
        this.options = [];
        this.words = [];
        this.fetchActivityRef = this.ds.firestoreRef()
            .collection(COLLECTION_NAME.ACTIVITY).doc(key)
            .valueChanges().subscribe(doc => {
                callback(doc)
            })
    }

    @action
    delete(item: any, callback) {
        this.ds.activityColRef().doc(item.key).delete().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

}
